import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { api } from '.';
import { SortOrderEnum } from '../shared/generated';
import { handleRequestError } from '../utils/request';
export var apiGetScheduledEmails = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var q, validationId, quoteId, limit, offset, _ref$sortOrder, sortOrder, _ref$sortColumn, sortColumn, status, res, _err$response, _err$response$data, _err$response$data$de, _err$response$data$de2, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            q = _ref.q, validationId = _ref.validationId, quoteId = _ref.quoteId, limit = _ref.limit, offset = _ref.offset, _ref$sortOrder = _ref.sortOrder, sortOrder = _ref$sortOrder === void 0 ? SortOrderEnum.ASC : _ref$sortOrder, _ref$sortColumn = _ref.sortColumn, sortColumn = _ref$sortColumn === void 0 ? 'created_at' : _ref$sortColumn, status = _ref.status;
            _context.prev = 1;
            _context.next = 4;
            return api.get('/scheduled_emails/', {
              params: {
                q: q,
                validation_id: validationId,
                quote_id: quoteId,
                status: status,
                limit: limit,
                offset: offset,
                sort: "".concat(sortColumn, ":").concat(sortOrder)
              }
            });

          case 4:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            message = (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$de = _err$response$data.detail) === null || _err$response$data$de === void 0 ? void 0 : (_err$response$data$de2 = _err$response$data$de[0]) === null || _err$response$data$de2 === void 0 ? void 0 : _err$response$data$de2.msg;
            console.error("Failed to fetch scheduled emails: ".concat(message));
            return _context.abrupt("return", [null, _context.t0]);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function apiGetScheduledEmails(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiDeleteScheduledEmail = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(emailId) {
    var res, _err$response2, _err$response2$data, _err$response2$data$d, _err$response2$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            if (emailId) {
              _context2.next = 3;
              break;
            }

            throw new Error("Invalid email id: ".concat(emailId));

          case 3:
            _context2.next = 5;
            return api["delete"]("/scheduled_emails/".concat(emailId));

          case 5:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data]);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            message = (_err$response2 = _context2.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$d = _err$response2$data.detail) === null || _err$response2$data$d === void 0 ? void 0 : (_err$response2$data$d2 = _err$response2$data$d[0]) === null || _err$response2$data$d2 === void 0 ? void 0 : _err$response2$data$d2.msg;
            console.error("Failed to fetch scheduled emails: ".concat(message));
            return _context2.abrupt("return", [null, _context2.t0]);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 9]]);
  }));

  return function apiDeleteScheduledEmail(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiSendTestScheduledEmail = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(emailId, emailAddress) {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;

            if (emailId) {
              _context3.next = 3;
              break;
            }

            throw new Error("Invalid email id: ".concat(emailId));

          case 3:
            if (emailAddress) {
              _context3.next = 5;
              break;
            }

            throw new Error("Invalid email address: ".concat(emailAddress));

          case 5:
            _context3.next = 7;
            return api.post("/scheduled_emails/".concat(emailId, "/send_test"), {
              to_email: emailAddress
            });

          case 7:
            res = _context3.sent;
            return _context3.abrupt("return", [res.data]);

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", handleRequestError(_context3.t0));

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 11]]);
  }));

  return function apiSendTestScheduledEmail(_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}();